<template>
  <div id="container">
    <div class="item-box-content">
      <div>
        <span class="bold"></span>
        <span class="basic">备货信息</span>
      </div>
      <!-------------- 备货信息 -------------->
      <stock-up-message
        ref="stockupMessageRefs"
        :id="queryParams.cusId"
        :InfoList="queryParams.customerRecevieInfoListVoList"
        :orderContractReceive="queryParams.customerRecevieInfo"
        :storageBaseList="queryParams.storageBaseList"
        :VoList="queryParams.customerRecevieMobileVoList"
      ></stock-up-message>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>备货清单</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">待备货产品</div>
            <!-----------  非期货 待备货产品 ----------->
            <el-table
              border
              ref="tableRef"
              :data="waitList"
              v-if="sourceType === 1"
              :header-cell-style="tableHeader"
              height="456px"
              @selection-change="selectW"
              @row-dblclick="dblclickW"
              empty-text='产品已全部移入备货区！'
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column prop="brandName" label="品牌" min-width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" min-width="90" show-overflow-tooltip></el-table-column>
              <el-table-column prop="cbExtimeValue" label="货期" min-width="90">
                <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
              </el-table-column>
              <el-table-column prop="cbNumber" label="数量" min-width="50"></el-table-column>
            </el-table>
            <el-col v-if="sourceType === 1" :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="immigrationAll">全部移入</el-button>
              <el-button type="primary" @click="immigration" plain>移入备货区</el-button>
            </el-col>
            <!-------------- 期货待备货产品 -------------->
            <div style="text-align: center;" v-if="sourceType === 2 && listFutures.length < 1">暂无数据</div>
            <futures-wait-stock-up
              ref="futuresWaitStockUpRefs"
              :storageAreaList="list"
              @getFuturesList="getFuturesList"
              @getdataList="getdataList"
              :bigArray="bigArray"
              :listFutures="listFutures"
              :sourceType="sourceType"
              v-if="sourceType === 2"
            ></futures-wait-stock-up>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">备货区</div>
            <el-table
              border
              ref="tableRef"
              :data="list"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              height="456px"
              row-key="id"
              @row-dblclick="dblclickR"
              @selection-change="handleSelectionChange"
              @select="listRowClick"
              empty-text='请选择备货产品！'
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column prop="brandName" label="品牌" min-width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" min-width="90" show-overflow-tooltip></el-table-column>
              <el-table-column prop="cbExtimeValue" label="货期">
                <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
              </el-table-column>
              <el-table-column label="数量" width="125" fixed="right">
                <template slot-scope="scope">
                  <el-input-number
                    style="width:100%"
                    controls-position="right"
                    @change="changeNumber"
                    @input="onNumber(scope.row)"
                    v-model="scope.row.cbNumber"
                    :min="0"
                    :max="scope.row.maxCount"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <!-- 非期货 -->
            <el-col :span="24" class="join-remove-sell-btn" v-if="sourceType === 1">
              <el-button type="primary" @click="onRemoveAll">全部移出</el-button>
              <el-button type="primary" @click="onRemove" plain>移出备货区</el-button>
            </el-col>
            <!-- 期货 -->
            <el-col :span="24" class="join-remove-sell-btn" v-if="sourceType === 2">
              <el-button type="primary" @click="onRemoveAllFutures">全部移出</el-button>
              <el-button type="primary" @click="onRemoveFutures" plain>移出备货区</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button type="primary" @click="startStockUp">发起备货</el-button>
    <open-or-close
      @onUpdataState="contractStockup"
      :content="content"
      title="确认备货"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import futuresWaitStockUp from './futuresWaitStockUp'
import stockUpMessage from './stockUpMessage'
import OpenOrClose from '@/components/OpenOrClose/index' // 提交审批,合同作废,合同审核不通过
import {
  queryShipmentByOcbId,
  orderContractStockup,
  saleInitiateStockup
} from '@/api/sell/sellManage'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'futures-wait-stock-up': futuresWaitStockUp,
    'stock-up-message': stockUpMessage
  },
  data() {
    return {
      // message: "",
      id: '', // 默认用户信息id
      list: [], // 备货区
      waitList: [], //  待备货产品 == 非期货
      queryParams: {},
      params: {}, //
      listFutures: [], // 待备货产品 == 期货
      checkList: [], // 选中的数据
      getRow: {},
      bigArray: null, // 备份数据
      stockupMessage: {}, // 备货信息
      flag: true, // 判断是否需要审批
      sourceType: 2, // 1为非期货 2为期货
      checkedWaitList: [], // 非期货 选中列表
      bigParams: [],
      content: '备货发起后无法撤回，是否确认备货？'
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 格式化数据list
    resetSetList() {
      for (let j = 0; j < this.list.length; j++) {
        if (this.list[j].cbNumber === 0) {
          this.list.splice(j, 1)
          j--
        }
      }
    },
    // 期货全部移出
    onRemoveAllFutures() {
      this.checkList = this.list
      this.onRemoveFutures()
    },
    // 期货移出
    onRemoveFutures() {
      if (this.checkList.length === 0) {
        this.$message.error('请选中产品！')
        return
      }
      for (let i = 0; i < this.checkList.length; i++) {
        for (let j = 0; j < this.list.length; j++) {
          if (
            this.checkList[i].ccId === this.list[j].ccId &&
            this.checkList[i].cbExtimeValue === this.list[j].cbExtimeValue
          ) {
            this.list[j].cbNumber = 0
            this.list[j].orderContractShipmentContentVoList = []
            this.$refs.futuresWaitStockUpRefs.onChangeNumber(this.list[j])
            this.list.splice(j, 1)
            j--
          }
        }
      }
      this.checkList = []
      this.resetSetList()
    },
    // 点击传回来数据
    getdataList(data) {
      const val = JSON.parse(JSON.stringify(data))
      for (let j = 0; j < val.length; j++) {
        delete val.isChecked
        let isFalseVal = false
        for (let i = 0; i < this.list.length; i++) {
          if (
            this.list[i].ccId === val[j].ccId &&
            this.list[i].cbExtimeValue === val[j].cbExtimeValue
          ) {
            isFalseVal = true
            let isFalse = false
            for (
              let z = 0;
              z < this.list[i].orderContractStockupContentSourceList;
              z++
            ) {
              for (
                let m = 0;
                m < val[j].orderContractStockupContentSourceList;
                z++
              ) {
                const model = this.list[i]
                  .orderContractStockupContentSourceList[z]
                const modelVal = val[j].orderContractStockupContentSourceList[m]

                if (model.id === modelVal.id) {
                  model.stockupCount += modelVal.stockupCount
                  isFalse = true
                }
              }
            }
            if (!isFalse) {
              this.list[i].orderContractStockupContentSourceList.push(
                val[j].orderContractStockupContentSourceList[0]
              )
            }
          }
        }
        if (!isFalseVal) {
          this.list.push(val[j])
        }
      }
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].cbNumber = 0
        for (
          let j = 0;
          j < this.list[i].orderContractStockupContentSourceList.length;
          j++
        ) {
          this.list[i].cbNumber += this.list[
            i
          ].orderContractStockupContentSourceList[j].stockupCount
        }
      }
    },
    // 提交备货
    contractStockup() {
      this.list.forEach((ele) => {
        ele.stockupCount = ele.cbNumber
        ele.orderContractStockupContentSourceList.forEach((item) => {
          item.stockupCount = ele.cbNumber
        })
      })
      const params = {
        ...this.stockupMessage,
        cusId: this.queryParams.cusId,
        ocbId: this.$route.query.id,
        orderContractStockupContentVoList: this.list
      }
      orderContractStockup(this.flag, params).then((res) => {
        if (res.data.code === 200) {
          const str = this.flag
            ? '已发起备货，请等待配货!'
            : '已发起备货审核，请等待审核!'
          this.$message.success(str)
          this.$router.push({
            name: 'contractEdit',
            query: {
              id: this.$route.query.id,
              cusId: this.queryParams.cusId
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 发起备货 判断是否需要审批
    startStockUp() {
      this.stockupMessage = {
        ...this.$refs.stockupMessageRefs.queryParams,
        ...this.$refs.stockupMessageRefs.consigneeParams
      }
      if (this.list.length === 0) {
        this.$message.error('请设置备货产品!')
        return
      }
      if (this.stockupMessage.deliveryTime) {
        if (
          this.stockupMessage.stockupType === '入库备货' &&
          !this.stockupMessage.storageId
        ) {
          this.$message.error('请填写完整备货信息!')
          return
        }
        if (this.stockupMessage.stockupType === '直发备货') {
          if (
            !this.stockupMessage.crName ||
            !this.stockupMessage.crPhone ||
            !this.stockupMessage.sendPeople ||
            !this.stockupMessage.sendPhone
          ) {
            this.$message.error('请填写完整备货信息!')
            return
          }
        }
      } else {
        this.$message.error('请选择预计发货时间!')
        return
      }
      this.list.forEach((ele) => {
        ele.stockupCount = ele.cbNumber
        ele.stockType = this.stockupMessage.stockupType
        ele.contractId = this.$route.query.id
      })
      saleInitiateStockup(this.list).then((res) => {
        if (res.data.code === 200) {
          this.flag = res.data.obj
          this.content = this.flag
            ? '备货发起后无法撤回，是否确认备货？'
            : '发起本次备货需提交上级审核，是否确认提交？'
          this.$refs.openOrCloseRefs.onInitial()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 备货详情产品信息列表
    getList() {
      queryShipmentByOcbId(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          this.queryParams = res.data.obj
          this.sourceType = res.data.obj.payType === 4 ? 2 : 1 // 4 期货
          if (res.data.obj.payType !== 4) {
            res.data.obj.orderContractContentList.forEach((ele) => {
              ele.isChecked = false
              ele.maxCount = ele.cbNumber
              ele.orderContractStockupContentSourceList = [
                {
                  sourceId: ele.sourceId,
                  sourceType: this.sourceType,
                  stockupCount: this.cbNumber // gaibain
                }
              ]
            })
            this.waitList = res.data.obj.orderContractContentList
          } else {
            this.bigArray = JSON.parse(
              JSON.stringify(res.data.obj.orderContractShipmentVoList)
            )
            this.listFutures = res.data.obj.orderContractShipmentVoList
            const isParams = []
            this.listFutures.forEach((item, index) => {
              item.orderContractShipmentContentVoList.forEach((ele) => {
                ele.isChecked = false
                ele.deliveryId = index
                isParams.push(ele)
              })
            })
            const bigList = JSON.parse(JSON.stringify(isParams))
            isParams.forEach((item, i) => {
              item.maxCount = 0
              this.listFutures.forEach((params) => {
                params.orderContractShipmentContentVoList.forEach((ele) => {
                  if (
                    ele.ccId === item.ccId &&
                    ele.cbExtimeValue === item.cbExtimeValue
                  ) {
                    item.maxCount += ele.cbNumber
                  }
                })
              })
              this.listFutures.forEach((params) => {
                params.orderContractShipmentContentVoList.forEach((ele) => {
                  if (
                    ele.ccId === item.ccId &&
                    ele.cbExtimeValue === item.cbExtimeValue
                  ) {
                    ele.maxCount = item.maxCount
                  }
                })
              })
            })
            this.bigParams = JSON.parse(JSON.stringify(isParams))
            for (let s = 0; s < this.bigParams.length; s++) {
              this.bigParams[s].orderContractStockupContentSourceList = []
              for (let n = 0; n < bigList.length; n++) {
                if (
                  bigList[n].ccId === this.bigParams[s].ccId &&
                  bigList[n].cbExtimeValue === this.bigParams[s].cbExtimeValue
                ) {
                  const obj = {
                    deliveryId: bigList[n].deliveryId,
                    sourceId: bigList[n].sourceId,
                    sourceType: this.sourceType,
                    stockupCount: bigList[n].cbNumber,
                    maxCount: this.bigParams[s].maxCount,
                    id: bigList[n].csId
                  }
                  this.bigParams[s].orderContractStockupContentSourceList.push(
                    obj
                  )
                }
              }
            }
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 期货期款列表传来的数据
    getFuturesList(val) {
      val.forEach((ele) => this.list.push(ele))
    },
    // 非期货  选中事件
    selectW(val) {
      this.checkedWaitList = val
    },
    dblclickW(row) {
      this.checkedWaitList = [row]
      this.immigration()
    },
    // 非期货 移入备货区
    immigration() {
      if (this.checkedWaitList.length === 0) {
        this.$message.error('请选择数据!')
      } else {
        this.checkedWaitList.forEach((param) => {
          this.waitList.forEach((ele, i) => {
            if (ele.id === param.id) {
              let isFalse = false
              if (this.list.length > 0) {
                this.list.forEach((val, j) => {
                  if (ele.id === val.id) {
                    this.list[j].cbNumber += this.waitList[i].cbNumber
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.list.push(this.waitList[i])
                }
              } else {
                this.list.push(this.waitList[i])
              }
            }
          })
        })
        this.checkedWaitList.forEach((param) => {
          this.waitList.forEach((item, index) => {
            if (item.id === param.id) {
              this.waitList.splice(index, 1)
              index--
            }
          })
        })
        this.checkedWaitList = []
      }
    },
    // 非期货 全部移入
    immigrationAll() {
      this.checkedWaitList = JSON.parse(JSON.stringify(this.waitList))
      this.immigration()
    },
    // 非期货 移出备货区
    onRemove() {
      if (this.checkList.length === 0) {
        this.$message.error('请选择数据!')
      } else {
        this.checkList.forEach((param) => {
          this.list.forEach((ele, i) => {
            if (ele.id === param.id) {
              let isFalse = false
              if (this.waitList.length > 0) {
                this.waitList.forEach((val, j) => {
                  if (ele.id === val.id) {
                    this.waitList[j].cbNumber += this.list[i].cbNumber
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.waitList.push(this.list[i])
                }
              } else {
                this.waitList.push(this.list[i])
              }
            }
          })
        })
        this.checkList.forEach((param) => {
          this.list.forEach((item, index) => {
            if (item.id === param.id) {
              this.list.splice(index, 1)
              index--
            }
          })
        })
        this.checkList = []
      }
    },
    // 非期货 全部移出
    onRemoveAll() {
      this.checkList = JSON.parse(JSON.stringify(this.list))
      this.onRemove()
    },
    // 列表数据是否选中
    listRowClick(selection, row) {
      row.isChecked = !row.isChecked
    },
    // 列表选中的数据
    handleSelectionChange(row) {
      this.checkList = row
    },
    dblclickR(row) {
      this.checkList = [row]
      if (this.sourceType === 1) {
        this.onRemove()
      } else {
        this.onRemoveFutures()
      }
    },
    // 改变备货区数量
    changeNumber(currentValue, old) {
      if (!currentValue) {
        this.getRow.cbNumber = old
        this.dblclickR(this.getRow)
        return
      }
      if (this.sourceType === 1) {
        const num = this.getRow.maxCount - this.getRow.cbNumber
        if (num === 0) {
          this.waitList.forEach((ele, index) => {
            if (ele.id === this.getRow.id) {
              this.waitList.splice(index, 1)
            }
          })
        } else {
          let isParam = false
          for (let i = 0; i < this.waitList.length; i++) {
            if (this.waitList[i].id === this.getRow.id) {
              isParam = true
              this.waitList[i].cbNumber = num
            }
          }
          if (!isParam) {
            const params = JSON.parse(JSON.stringify(this.getRow))
            params.cbNumber = num
            this.waitList.push(params)
          }
        }
      } else {
        // 往小减的
        if (old - currentValue > 0) {
          let count = old - currentValue
          for (let i = 0; i < this.list.length; i++) {
            if (
              this.getRow.ccId === this.list[i].ccId &&
              this.getRow.cbExtimeValue === this.list[i].cbExtimeValue
            ) {
              const isCount = []
              for (
                let z = 0;
                z < this.list[i].orderContractStockupContentSourceList.length;
                z++
              ) {
                isCount.push(
                  this.list[i].orderContractStockupContentSourceList[z]
                    .deliveryId
                )
              }
              isCount.sort((a, b) => b - a)
              let isCountFalse = false
              for (let m = 0; m < isCount.length; m++) {
                for (
                  let z = 0;
                  z < this.list[i].orderContractStockupContentSourceList.length;
                  z++
                ) {
                  if (
                    isCount[m] ===
                      this.list[i].orderContractStockupContentSourceList[z]
                        .deliveryId &&
                    !isCountFalse
                  ) {
                    const data = JSON.parse(
                      JSON.stringify(
                        this.list[i].orderContractStockupContentSourceList[z]
                          .stockupCount
                      )
                    )
                    const counts = count
                    if (data <= count) {
                      count =
                        count -
                        this.list[i].orderContractStockupContentSourceList[z]
                          .stockupCount
                      this.list[i].orderContractStockupContentSourceList.splice(
                        z,
                        1
                      )
                      z--
                    }
                    if (data > counts) {
                      this.list[i].orderContractStockupContentSourceList[
                        z
                      ].stockupCount =
                        this.list[i].orderContractStockupContentSourceList[z]
                          .stockupCount - count
                      isCountFalse = true
                    }
                  }
                }
              }
              this.$refs.futuresWaitStockUpRefs.onChangeNumber(this.list[i])
            }
          }
        } else if (currentValue - old > 0) {
          let count = currentValue - old
          for (let h = 0; h < this.list.length; h++) {
            if (
              this.getRow.ccId === this.list[h].ccId &&
              this.getRow.cbExtimeValue === this.list[h].cbExtimeValue
            ) {
              for (let i = 0; i < this.bigParams.length; i++) {
                if (
                  this.list[h].ccId === this.bigParams[i].ccId &&
                  this.list[h].cbExtimeValue === this.bigParams[i].cbExtimeValue
                ) {
                  for (
                    let j = 0;
                    j <
                    this.bigParams[i].orderContractStockupContentSourceList
                      .length;
                    j++
                  ) {
                    let isData = false
                    const model = this.bigParams[i]
                      .orderContractStockupContentSourceList[j]

                    for (
                      let b = 0;
                      b <
                      this.list[h].orderContractStockupContentSourceList.length;
                      b++
                    ) {
                      const getRow = this.list[h]
                        .orderContractStockupContentSourceList[b]

                      if (getRow.deliveryId === model.deliveryId) {
                        if (
                          model.stockupCount - getRow.stockupCount >= count &&
                          count >= 0
                        ) {
                          getRow.stockupCount += count
                        }
                        if (model.stockupCount - getRow.stockupCount < count) {
                          const num = model.stockupCount - getRow.stockupCount
                          getRow.stockupCount = model.stockupCount
                          count = count - num
                        }
                        isData = true
                      }
                    }
                    if (!isData) {
                      const param = JSON.parse(JSON.stringify(model))
                      if (param.stockupCount >= count && count > 0) {
                        param.stockupCount = JSON.parse(JSON.stringify(count))

                        this.list[h].orderContractStockupContentSourceList.push(
                          param
                        )
                        count = 0
                      }
                      if (param.stockupCount < count) {
                        count = count - param.stockupCount
                        this.list[h].orderContractStockupContentSourceList.push(
                          param
                        )
                      }
                    }
                  }
                }
              }
              // 数量增加未修改
            }
            this.$refs.futuresWaitStockUpRefs.onChangeNumber(this.list[h])
          }
        } else {
        }
      }
    },
    // 拿到列表中的当前行数据
    onNumber(row) {
      row.cbNumber = Math.floor(row.cbNumber)
      this.getRow = row
    }
  }
}
</script>
